import React from 'react';
import createTrack from 'services/actions/tracker_actions';
import { Container } from './styles';

interface BannerProps {
  linkUrl: string;
  imageUrl: string;
  alt: string;
}

const Banner: React.FC<BannerProps> = ({ linkUrl, imageUrl, alt = 'banner' }) => {
  return (
    <Container>
      <button
        type="button"
        className="w-100 h-100 border-0"
        onClick={async () => {
          window.open(linkUrl, '_blank');
          createTrack(`Banner - ${alt}`);
        }}
      >
        <img src={imageUrl} className="img-banner" alt={alt} />
      </button>
    </Container>
  );
};

export default Banner;
